/**
 * Oprávnění modulu Inventory (frontend zrcadlí backend `InventoryPermissions`).
 * `read` = zobrazení agendy Vehicle inventory (menu, seznam, export, detail, selektory),
 * `edit` = založení a editace vozu.
 */
export const INVENTORY_VEHICLES = 'inventory.vehicles';

/**
 * Oprávnění agendy leteckých společností. Je to **sourozenec** `inventory.vehicles`, ne potomek —
 * grant na vozy leteckou agendu neotevírá a naopak.
 * `read` = menu, seznam, export, detail; `edit` = založení a editace.
 */
export const INVENTORY_AIRLINES = 'inventory.airlines';
